/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import { FETCH_SURVEY_QUESTIONS, POST_SURVEY_ANSWERS } from './actionTypes';

/**
 * Updates the details in the 'Survey' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchSurveyQuestionsReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_SURVEY_QUESTIONS);

/**
 * Updates the indicator of creation of details in the 'Survey' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchSurveyQuestionsReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_SURVEY_QUESTIONS);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchSurveyQuestionsErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_SURVEY_QUESTIONS);

/**
 * Updates the details in the 'Survey' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postSurveyAnswersReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_SURVEY_ANSWERS);

/**
 * Updates the indicator of creation of details in the 'Survey' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostSurveyAnswersReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_SURVEY_ANSWERS);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postSurveyAnswersErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_SURVEY_ANSWERS);

const reducers = combineReducers({
  fetchSurveyQuestions: fetchSurveyQuestionsReducer,

  isFetchingFetchSurveyQuestions: isFetchingFetchSurveyQuestionsReducer,
  fetchSurveyQuestionsError: fetchSurveyQuestionsErrorReducer,

  postSurveyAnswers: postSurveyAnswersReducer,

  isFetchingPostSurveyAnswers: isFetchingPostSurveyAnswersReducer,
  postSurveyAnswersError: postSurveyAnswersErrorReducer,
});

export default { reducers };
